type ErrorHandler = {
    condition: (code: string) => boolean;
    handle: (
      data: {
        response: {
          data: {
            code: string;
            message: string;
            context: {
              unavailableTickets: number[]
            }
          }
        }
      }
    ) => void;
  };

export const createErrorHandlers = (
  locale: string,
  handleSetErrorsInSummary: (errors: { id: number; error: string }[]) => void,
  defineTitleModal: (title: string) => void,
  getErrorMessage: (code: string, locale: string, message:string) => string,
  translate: (keys: string[]) => string
): ErrorHandler[] => [
  {
    condition : (code) => code === 'ES0301',
    handle : (data) => {
      const errorTickets = data.response.data.context.unavailableTickets ?? [];
      handleSetErrorsInSummary(
        errorTickets.map((id) => ({
          id : typeof id === 'string' ? parseInt(id, 10) : id,
          error : getErrorMessage(data.response.data.code, locale, data.response.data.message ),
        }))
      );
      defineTitleModal(translate(['INFORMATION', 'BENEFIT_ALERT_TITLE']));
    },
  },
  {
    condition : (code) => code === 'ES0101' || code === 'ES0108',
    handle : (data) => {
      const errorTickets = data.response.data.context.unavailableTickets ?? [];
      handleSetErrorsInSummary(
        errorTickets.map((id) => ({
          id : typeof id === 'string' ? parseInt(id, 10) : id,
          error : getErrorMessage(data.response.data.code, locale, data.response.data.message),
        }))
      );
      defineTitleModal(translate(['INFORMATION', 'BENEFIT_ALERT_TITLE']));
    },
  },
  {
    condition : (code) => code === 'ES0116',
    handle : (data) => {
      data && defineTitleModal(translate(['INFORMATION', 'MEIA_ENTRADA_NOT_FOUND_TITLE']));
    },
  },
  {
    condition : (code) => code === 'ES0115',
    handle : (data) => {
      data && defineTitleModal(translate(['INFORMATION', 'TICKET_LIMIT_TITLE']));
    },
  },
  {
    condition : (code) => !!code, // Fallback, add new error handlers above this one
    handle : (data) => {
      data && defineTitleModal(`Error ${data.response.data.code}`);
    },
  },
];
